import React from 'react';

const PeopleIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M17.5291 7.77C17.4591 7.76 17.3891 7.76 17.3191 7.77C15.7691 7.72 14.5391 6.45 14.5391 4.89C14.5391 3.3 15.8291 2 17.4291 2C19.0191 2 20.3191 3.29 20.3191 4.89C20.3091 6.45 19.0791 7.72 17.5291 7.77Z"
      fill="white"
    />
    <path
      opacity="0.4"
      d="M20.7916 14.6999C19.6716 15.4499 18.1016 15.7299 16.6516 15.5399C17.0316 14.7199 17.2316 13.8099 17.2416 12.8499C17.2416 11.8499 17.0216 10.8999 16.6016 10.0699C18.0816 9.86992 19.6516 10.1499 20.7816 10.8999C22.3616 11.9399 22.3616 13.6499 20.7916 14.6999Z"
      fill="white"
    />
    <path
      opacity="0.4"
      d="M6.43843 7.77C6.50843 7.76 6.57844 7.76 6.64844 7.77C8.19844 7.72 9.42844 6.45 9.42844 4.89C9.42844 3.3 8.13844 2 6.53844 2C4.94844 2 3.64844 3.29 3.64844 4.89C3.65844 6.45 4.88843 7.72 6.43843 7.77Z"
      fill="white"
    />
    <path
      opacity="0.4"
      d="M6.55109 12.8501C6.55109 13.8201 6.76109 14.7401 7.14109 15.5701C5.73109 15.7201 4.26109 15.4201 3.18109 14.7101C1.60109 13.6601 1.60109 11.9501 3.18109 10.9001C4.25109 10.1801 5.76109 9.8901 7.18109 10.0501C6.77109 10.8901 6.55109 11.8401 6.55109 12.8501Z"
      fill="white"
    />
    <path
      d="M12.1208 15.87C12.0408 15.86 11.9508 15.86 11.8608 15.87C10.0208 15.81 8.55078 14.3 8.55078 12.44C8.55078 10.54 10.0808 9 11.9908 9C13.8908 9 15.4308 10.54 15.4308 12.44C15.4308 14.3 13.9708 15.81 12.1208 15.87Z"
      fill="white"
    />
    <path
      d="M8.87078 17.9401C7.36078 18.9501 7.36078 20.6101 8.87078 21.6101C10.5908 22.7601 13.4108 22.7601 15.1308 21.6101C16.6408 20.6001 16.6408 18.9401 15.1308 17.9401C13.4208 16.7901 10.6008 16.7901 8.87078 17.9401Z"
      fill="white"
    />
  </svg>
);

export default PeopleIcon;
